'use strict';

const LoginModalConfig={
templateUrl:'/templates/features/login/modals/loginModalView',
controller:'LoginModalController as controller',
backdrop:'static',
windowClass:'login-modal',
keyboard:!1,
resolve:{
reason:()=>null}};



module.exports=LoginModalConfig;
//# sourceMappingURL=loginModalConfig.js.map
